import { Label, Value, Wrapper } from './RankStyles';

export interface RankProps {
  color: string;
  rank: string;
  className?: string;
}

const Rank = ({ color, rank, className = '' }: RankProps) => (
  <Wrapper
    color={color}
    className={className}
  >
    <Label className='label'>Rank</Label>
    <Value className='value'>{rank}</Value>
  </Wrapper>
);

export default Rank;
